// extracted by mini-css-extract-plugin
export default {"container":"StyledDropdown-module__container--oa0s4"};